import $ from 'jquery'

const modalSelector = '#check-reconciliation-texts-modal'
const modalCheckboxesSelector =
  '.check_list_checks_reconciliation_text_ids input[type="checkbox"]'
const modalCheckedCheckboxesSelector = `${modalCheckboxesSelector}:checked`
const checkFieldsSelector = '[data-behaviour="check-fields"]'

$(document).on(
  'cocoon:before-insert',
  '[data-behaviour~="check-list"]',
  (_e, insertedItem) => {
    const newId = Math.random().toString(36).substr(2, 9)
    const oldId = new RegExp(
      $(insertedItem).find('[data-check-id]').data('checkId'),
      'g'
    )
    const htmlWithNewId = $(insertedItem).html().replace(oldId, newId)
    $(insertedItem).html(htmlWithNewId)
  }
)

$(document).on(
  'change',
  'input[type=checkbox][data-behaviour~="check-list-input-checkbox"]',
  (_e) => {
    const modal = $(modalSelector)
    const checkId = modal.data('checkId')

    const content = I18n.t('js.check_lists.reconciliations', {
      count: modal.find(modalCheckedCheckboxesSelector).length,
    })

    const $scope = $(`[data-check-id="${checkId}"`).parents(checkFieldsSelector)
    $scope.find('[data-behaviour~="check-text-count"]').html(content)
  }
)

$(document).on('change', `${checkFieldsSelector} select`, (e) => {
  const $select = $(e.target)
  const $fields = $select.closest(checkFieldsSelector)
  const $range = $fields.find('[data-behaviour~="check-account-range"]')
  const $text = $fields.find('[data-behaviour~="check-reconciliation-texts"]')

  $range.hide()
  $text.hide()

  switch ($select.val()) {
    case 'AccountEntry':
      $range.show()
      break
    case 'ReconciliationText':
      $text.show()
      break
  }
})

$(document).on('click', '[data-behaviour~="check-fields-destroy"]', (e) => {
  const button = $(e.currentTarget)

  window.sfConfirm({
    question: I18n.t('check_lists.remove_check_with_checkins'),
    onConfirm: () => {
      window.eventHub.$emit('destroy-check-link')
      button.find('.remove_fields').click()
    },
  })
})

$(document).on(
  'click',
  '[data-target="#check-reconciliation-texts-modal"]',
  (e) => {
    const $el = $(e.currentTarget)
    // find the parent element of this modal trigger button, then load the value of the hidden field for selected RTs
    const selectedRts = $el
      .parents(checkFieldsSelector)
      .find('.js-selected-rt-ids')
      .val()
    const modal = $(modalSelector)

    // the modal is re-used for all checks, so we need to tick off the correct RTs every time we open it
    modal.find(modalCheckboxesSelector).each((_idx, el) => {
      const checkbox = $(el)
      const rtId = checkbox.data('rtId')
      const checked = selectedRts.indexOf(rtId) >= 0 ? 'checked' : null
      checkbox.prop('checked', checked)
    })

    // set the currently open check-id on the modal, so it's available when we close it + the description
    const checkId = $el.data('checkId')
    modal.data('checkId', checkId)

    const checkDescription =
      $el.parents(checkFieldsSelector).find('textarea').val() ?? ''
    modal.find('.modal-title').text(checkDescription)
  }
)

$(document).on('hide', modalSelector, (e) => {
  const modal = $(e.currentTarget)

  // find all selected RTs
  const selectedRts = modal
    .find(modalCheckedCheckboxesSelector)
    .map((_i, element) => $(element).data('rtId'))
    .toArray()

  const checkId = modal.data('checkId')
  // store the selected RTs on the input corresponding to the check that initially triggered the modal
  $(`[data-check-id="${checkId}"]`)
    .parents(checkFieldsSelector)
    .find('.js-selected-rt-ids')
    .val(JSON.stringify(selectedRts))
})
